module.exports = __webpack_public_path__ + "static/media/DSC_0212.b3868c16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0212.jpg
// module id = 648
// module chunks = 0